export default "__VITE_ASSET__Brxlytue__"